export default __webpack_public_path__ + "static/media/DGX-B200.0da246d2.png";